
export const setExitAction = () => {
  return {
    type: 'SET_EXIT',
    data: true,
  };
};
